import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClosereact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.58578 8.00012L1.63603 3.05037C1.24551 2.65984 1.24551 2.02668 1.63603 1.63615C2.02656 1.24563 2.65972 1.24563 3.05025 1.63615L7.99999 6.5859L12.9497 1.63615C13.3403 1.24563 13.9734 1.24563 14.364 1.63615C14.7545 2.02668 14.7545 2.65984 14.364 3.05037L9.41421 8.00012L14.364 12.9499C14.7545 13.3404 14.7545 13.9736 14.364 14.3641C13.9734 14.7546 13.3403 14.7546 12.9497 14.3641L7.99999 9.41433L3.05025 14.3641C2.65972 14.7546 2.02656 14.7546 1.63603 14.3641C1.24551 13.9736 1.24551 13.3404 1.63603 12.9499L6.58578 8.00012Z"
	})
});
export default SvgClosereact;
